import { AutomationModel, TSingleAutomationStats  } from "@cakemail-org/ui-components-v2"

export type TABTestsContext = {

}

export enum EABTestsNav {
    All = "all",
    Draft = "draft",
    Active = "active",
    Completed = "completed"
}

export type TABTestsListing = {
    // Initial tab to display
    initTab?: EABTestsNav
}

export type TABTestStats = {
    data: TSingleAutomationStats
}


export type TABTestWithStats = AutomationModel & {
    statsA?: TABTestStats
    statsB?: TABTestStats
    statsC?: TABTestStats
    statsD?: TABTestStats
}

export type TABTestStatus = "draft" | "active" | "completed"

export type TWinnerPath = "pathA" | "pathB" | "pathC" | "pathD"

export type TABTestCachedData = {
    thumbnails: {
        [key in TWinnerPath]?: string  // URL to email thumbnail
    }
    name: string                        // Email subject/name
    totalNumberOfSegments: number       // Number of segments targeted
    listName?: string                   // Contact list name
}

export type TABTestsCache = {
    [automationId: number]: TABTestCachedData
}
